import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.bereich-detail';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichDetailEffects {

    BereichDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BEREICH_DETAIL),
        mergeMap((x: ac.GetBereichDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBereichDetail(x.bereich_id).pipe(
                map((result: any) => {
                    return new ac.GetBereichDetailErfolgreichAction(result, x.bereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBereichDetailFehlerAction(error, x.bereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungQueryService);
        }
        return this.service;
    }
}
